// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* BrushMenu.css */
.brush-menu, .effect-menu {
  position: fixed;
  max-height: 95vh; /* Максимальная высота 90% от высоты экрана */
  overflow-y: auto; /* Добавляем вертикальную прокрутку при необходимости */
  
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 270px;
  text-align: center;
  background-color: var(--tg-theme-bg-color);

  padding: 0px;
  padding-top: 5px;

  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.2);
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 1100;
}

.brush-menu * {
  touch-action: pan-y;
}
.effect-menu * {
  touch-action: pan-y;
}

.brush-menu-header {
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0 15px 5px 15px;
  border-bottom: 1px solid #eee;
}

.brush-menu-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.brush-menu-action-btn {
  background: none;
  border: none;
  color: var(--tg-theme-button-color);
  font-size: 22px;
  cursor: pointer;
  padding: 8px 3px 1px 3px;
  opacity: 0.7;
}
.brush-menu-action-btn:hover {
  opacity: 0.7;
}

.delete-drop-zone {
  color: var(--tg-theme-hint-color);
  font-size: 22px;
  padding: 5px 5px 1px 5px;
  border-radius: 8px;
  transition: all 0.2s ease;
  visibility: hidden;
}

.delete-drop-zone.visible {
  visibility: visible;
}

.delete-drop-zone.active {
  color: var(--tg-theme-destructive-text-color);
  background-color: rgba(255, 0, 0, 0.1);
  transform: scale(1.2);
}

.brush-menu-title {
  display: flex;
  align-items: center;
  cursor: pointer;

  color: var(--tg-theme-button-color); /* Синий цвет */
  font-size: 24px;
}

.brush-menu-list {
  width: 100%;
  overflow-y: auto; 
  overflow-x: hidden;
  
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.brush-menu-list * {
  touch-action: pan-y;
}

.brush-category-switcher {
  border-top: 1px solid #eee;
  display: flex;
  justify-content: center;
  gap: 0px;
  padding: 5px;
  width: 100%;
}

.category-btn {
  padding: 8px 10px;
  border-radius: 14px;
  cursor: pointer;
  color: var(--tg-theme-button-color);
  background: var(--tg-theme-bg-color);
  border-width: 0px;
  font-size: 16px;
}

.category-btn.active {
  background: var(--tg-theme-button-color);
  color: var(--tg-theme-button-text-color);
}

.brush-option-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: none;
  color: var(--tg-theme-text-color);
  border-radius: 14px;  /* Добавлено для фона активной кнопки */
  margin: 1px;
  padding: 5px 10px 5px 0px;
  cursor: pointer;
  opacity: 1;
  width: 90%;
  border: 1px solid transparent;
  background-color: rgba(138, 138, 138, 0.07);
}

.brush-option-row.active {
  color: var(--tg-theme-button-text-color);
  background-color: var(--tg-theme-button-color);
  border-radius: 14px;  /* Добавлено для фона активной кнопки */
  opacity: 1;
}

.brush-option-row:not(.active):hover {
  background-color: rgba(138, 138, 138, 0.15);
}

.brush-option-row.not-available {
  opacity: 0.5;
}

.brush-option-row.dragging {
  opacity: 0.7;
  border: 1.5px dashed var(--tg-theme-text-color);
  box-sizing: content-box;
}

.brush-option-row.drag-over.drag-over-up {
  border-top: 2px solid var(--tg-theme-button-color);
}

.brush-option-row.drag-over.drag-over-down {
  border-bottom: 2px solid var(--tg-theme-button-color);
}

.brush-option-row.in-group {
  border-radius: 12px 12px 12px 12px;
  margin-left: 10px;
  width: calc(90% - 10px);
  border-left: 2px solid rgba(138, 138, 138, 0.20);
}

.brush-drag-handle {
  cursor: move;
  padding: 0 4px;
  font-size: 22px;
  opacity: 0.3;
  color: var(--tg-theme-text-color);
  touch-action: none; 
}

.brush-option-row:hover .drag-handle {
  opacity: 1;
}

.brush-option-row.active .drag-handle {
  color: var(--tg-theme-button-text-color);
}

.brush-icon {
  width: 25px;
  height: 25px;
  margin: 2px;
  margin-right: 8px;
  color: var(--tg-theme-button-color); /* Синий цвет */
  padding-left: 5px; 
  padding-right: 5px; 
  text-align: left;
}

.brush-icon.active {
  color: var(--tg-theme-button-text-color); /* Синий цвет */
}

.brush-icon.not-available {
  color: var(--tg-theme-hint-color, rgb(163, 163, 163)); /* Серый цвет */
}

.brush-label {
  display: flex;
  width: 100%;
  max-width: 100%;
  align-items: center;
  cursor: pointer;
  font-size: 15px;
  padding-left: 5px; 
  padding-right: 5px; 
  text-align: left;
}

.brush-group-row {
  display: flex;
  align-items: center;
  width: 90%;
  padding: 2px 12px 2px 5px;
  margin: 1px 8px 1px 1px;
  border-radius: 0px 12px 12px 0px;
  cursor: pointer;
  border: 1px solid transparent;
}

.brush-group-row.expanded {
  border-radius: 0px 12px 12px 0px;
  background-color: rgba(138, 138, 138, 0.07);
}


.brush-group-row.drag-over-group {
  background-color: rgba(115, 185, 255, 0.2);
  border: 1.5px dashed var(--tg-theme-button-color);
}

.brush-group-row:hover {
  background-color: rgba(138, 138, 138, 0.13);
}

.brush-group-row.dragging {
  opacity: 0.7;
  background-color: transparent;
  border: 1.5px dashed var(--tg-theme-text-color);
}

.brush-group-row.drag-over.drag-over-up {
  border-top: 2px solid var(--tg-theme-button-color);
}

.brush-group-row.drag-over.drag-over-down {
  border-bottom: 2px solid var(--tg-theme-button-color);
}

.brush-group-toggle {
  padding: 0 8px;
  font-size: 14px;
  width: 18px; /* For alignment */
  text-align: center;
  opacity: 0.7;
  color: var(--tg-theme-text-color);
  /* color: var(--tg-theme-button-color); */

}

.brush-group-label {
  flex-grow: 1;
  text-align: left;
  color: var(--tg-theme-text-color);
  /* color: var(--tg-theme-button-color); */
}

.brush-group-label-count {
  margin-left: 8px;
  color: var(--tg-theme-hint-color);
}

.brush-settings-icon {
  margin-left: auto;
  margin-right: 0px;
  width: 25px;
  height: 25px;
  color: var(--tg-theme-button-text-color);
  cursor: pointer;
}

.add-group-button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 90%;
  margin: 5px auto;
  padding: 2px 8px;
  border-radius: 12px;
  cursor: pointer;
  color: var(--tg-theme-button-color);
  background: rgba(138, 138, 138, 0.07);
  border: 1.5px dashed var(--tg-theme-button-color);
  opacity: 1;
}

.add-group-button:hover {
  opacity: 1;
  background: rgba(138, 138, 138, 0.15);
}

.brush-row-ghost {
  opacity: 0.8;
  background-color: var(--tg-theme-secondary-bg-color);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.5);
  border-radius: 14px;
  padding: 0;
}


`, "",{"version":3,"sources":["webpack://./src/components/menus/brush/BrushMenu.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE,eAAe;EACf,gBAAgB,EAAE,6CAA6C;EAC/D,gBAAgB,EAAE,uDAAuD;;EAEzE,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;;EAE1C,YAAY;EACZ,gBAAgB;;EAEhB,yCAAyC;EACzC,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,mCAAmC;EACnC,eAAe;EACf,eAAe;EACf,wBAAwB;EACxB,YAAY;AACd;AACA;EACE,YAAY;AACd;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,wBAAwB;EACxB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6CAA6C;EAC7C,sCAAsC;EACtC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;;EAEf,mCAAmC,EAAE,eAAe;EACpD,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;;EAElB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,mCAAmC;EACnC,oCAAoC;EACpC,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,wCAAwC;EACxC,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,iCAAiC;EACjC,mBAAmB,GAAG,uCAAuC;EAC7D,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,UAAU;EACV,UAAU;EACV,6BAA6B;EAC7B,2CAA2C;AAC7C;;AAEA;EACE,wCAAwC;EACxC,8CAA8C;EAC9C,mBAAmB,GAAG,uCAAuC;EAC7D,UAAU;AACZ;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,+CAA+C;EAC/C,uBAAuB;AACzB;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,kCAAkC;EAClC,iBAAiB;EACjB,uBAAuB;EACvB,gDAAgD;AAClD;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,mCAAmC,EAAE,eAAe;EACpD,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,wCAAwC,EAAE,eAAe;AAC3D;;AAEA;EACE,qDAAqD,EAAE,eAAe;AACxE;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,yBAAyB;EACzB,uBAAuB;EACvB,gCAAgC;EAChC,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;EAChC,2CAA2C;AAC7C;;;AAGA;EACE,0CAA0C;EAC1C,iDAAiD;AACnD;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,+CAA+C;AACjD;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,cAAc;EACd,eAAe;EACf,WAAW,EAAE,kBAAkB;EAC/B,kBAAkB;EAClB,YAAY;EACZ,iCAAiC;EACjC,yCAAyC;;AAE3C;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,iCAAiC;EACjC,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,wCAAwC;EACxC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,mCAAmC;EACnC,qCAAqC;EACrC,iDAAiD;EACjD,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,wCAAwC;EACxC,mBAAmB;EACnB,UAAU;AACZ","sourcesContent":["/* BrushMenu.css */\n.brush-menu, .effect-menu {\n  position: fixed;\n  max-height: 95vh; /* Максимальная высота 90% от высоты экрана */\n  overflow-y: auto; /* Добавляем вертикальную прокрутку при необходимости */\n  \n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 270px;\n  text-align: center;\n  background-color: var(--tg-theme-bg-color);\n\n  padding: 0px;\n  padding-top: 5px;\n\n  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.2);\n  border-radius: 12px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  z-index: 1100;\n}\n\n.brush-menu * {\n  touch-action: pan-y;\n}\n.effect-menu * {\n  touch-action: pan-y;\n}\n\n.brush-menu-header {\n  box-sizing: border-box;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  padding: 0 15px 5px 15px;\n  border-bottom: 1px solid #eee;\n}\n\n.brush-menu-actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.brush-menu-action-btn {\n  background: none;\n  border: none;\n  color: var(--tg-theme-button-color);\n  font-size: 22px;\n  cursor: pointer;\n  padding: 8px 3px 1px 3px;\n  opacity: 0.7;\n}\n.brush-menu-action-btn:hover {\n  opacity: 0.7;\n}\n\n.delete-drop-zone {\n  color: var(--tg-theme-hint-color);\n  font-size: 22px;\n  padding: 5px 5px 1px 5px;\n  border-radius: 8px;\n  transition: all 0.2s ease;\n  visibility: hidden;\n}\n\n.delete-drop-zone.visible {\n  visibility: visible;\n}\n\n.delete-drop-zone.active {\n  color: var(--tg-theme-destructive-text-color);\n  background-color: rgba(255, 0, 0, 0.1);\n  transform: scale(1.2);\n}\n\n.brush-menu-title {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n\n  color: var(--tg-theme-button-color); /* Синий цвет */\n  font-size: 24px;\n}\n\n.brush-menu-list {\n  width: 100%;\n  overflow-y: auto; \n  overflow-x: hidden;\n  \n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.brush-menu-list * {\n  touch-action: pan-y;\n}\n\n.brush-category-switcher {\n  border-top: 1px solid #eee;\n  display: flex;\n  justify-content: center;\n  gap: 0px;\n  padding: 5px;\n  width: 100%;\n}\n\n.category-btn {\n  padding: 8px 10px;\n  border-radius: 14px;\n  cursor: pointer;\n  color: var(--tg-theme-button-color);\n  background: var(--tg-theme-bg-color);\n  border-width: 0px;\n  font-size: 16px;\n}\n\n.category-btn.active {\n  background: var(--tg-theme-button-color);\n  color: var(--tg-theme-button-text-color);\n}\n\n.brush-option-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background: none;\n  color: var(--tg-theme-text-color);\n  border-radius: 14px;  /* Добавлено для фона активной кнопки */\n  margin: 1px;\n  padding: 5px 10px 5px 0px;\n  cursor: pointer;\n  opacity: 1;\n  width: 90%;\n  border: 1px solid transparent;\n  background-color: rgba(138, 138, 138, 0.07);\n}\n\n.brush-option-row.active {\n  color: var(--tg-theme-button-text-color);\n  background-color: var(--tg-theme-button-color);\n  border-radius: 14px;  /* Добавлено для фона активной кнопки */\n  opacity: 1;\n}\n\n.brush-option-row:not(.active):hover {\n  background-color: rgba(138, 138, 138, 0.15);\n}\n\n.brush-option-row.not-available {\n  opacity: 0.5;\n}\n\n.brush-option-row.dragging {\n  opacity: 0.7;\n  border: 1.5px dashed var(--tg-theme-text-color);\n  box-sizing: content-box;\n}\n\n.brush-option-row.drag-over.drag-over-up {\n  border-top: 2px solid var(--tg-theme-button-color);\n}\n\n.brush-option-row.drag-over.drag-over-down {\n  border-bottom: 2px solid var(--tg-theme-button-color);\n}\n\n.brush-option-row.in-group {\n  border-radius: 12px 12px 12px 12px;\n  margin-left: 10px;\n  width: calc(90% - 10px);\n  border-left: 2px solid rgba(138, 138, 138, 0.20);\n}\n\n.brush-drag-handle {\n  cursor: move;\n  padding: 0 4px;\n  font-size: 22px;\n  opacity: 0.3;\n  color: var(--tg-theme-text-color);\n  touch-action: none; \n}\n\n.brush-option-row:hover .drag-handle {\n  opacity: 1;\n}\n\n.brush-option-row.active .drag-handle {\n  color: var(--tg-theme-button-text-color);\n}\n\n.brush-icon {\n  width: 25px;\n  height: 25px;\n  margin: 2px;\n  margin-right: 8px;\n  color: var(--tg-theme-button-color); /* Синий цвет */\n  padding-left: 5px; \n  padding-right: 5px; \n  text-align: left;\n}\n\n.brush-icon.active {\n  color: var(--tg-theme-button-text-color); /* Синий цвет */\n}\n\n.brush-icon.not-available {\n  color: var(--tg-theme-hint-color, rgb(163, 163, 163)); /* Серый цвет */\n}\n\n.brush-label {\n  display: flex;\n  width: 100%;\n  max-width: 100%;\n  align-items: center;\n  cursor: pointer;\n  font-size: 15px;\n  padding-left: 5px; \n  padding-right: 5px; \n  text-align: left;\n}\n\n.brush-group-row {\n  display: flex;\n  align-items: center;\n  width: 90%;\n  padding: 2px 12px 2px 5px;\n  margin: 1px 8px 1px 1px;\n  border-radius: 0px 12px 12px 0px;\n  cursor: pointer;\n  border: 1px solid transparent;\n}\n\n.brush-group-row.expanded {\n  border-radius: 0px 12px 12px 0px;\n  background-color: rgba(138, 138, 138, 0.07);\n}\n\n\n.brush-group-row.drag-over-group {\n  background-color: rgba(115, 185, 255, 0.2);\n  border: 1.5px dashed var(--tg-theme-button-color);\n}\n\n.brush-group-row:hover {\n  background-color: rgba(138, 138, 138, 0.13);\n}\n\n.brush-group-row.dragging {\n  opacity: 0.7;\n  background-color: transparent;\n  border: 1.5px dashed var(--tg-theme-text-color);\n}\n\n.brush-group-row.drag-over.drag-over-up {\n  border-top: 2px solid var(--tg-theme-button-color);\n}\n\n.brush-group-row.drag-over.drag-over-down {\n  border-bottom: 2px solid var(--tg-theme-button-color);\n}\n\n.brush-group-toggle {\n  padding: 0 8px;\n  font-size: 14px;\n  width: 18px; /* For alignment */\n  text-align: center;\n  opacity: 0.7;\n  color: var(--tg-theme-text-color);\n  /* color: var(--tg-theme-button-color); */\n\n}\n\n.brush-group-label {\n  flex-grow: 1;\n  text-align: left;\n  color: var(--tg-theme-text-color);\n  /* color: var(--tg-theme-button-color); */\n}\n\n.brush-group-label-count {\n  margin-left: 8px;\n  color: var(--tg-theme-hint-color);\n}\n\n.brush-settings-icon {\n  margin-left: auto;\n  margin-right: 0px;\n  width: 25px;\n  height: 25px;\n  color: var(--tg-theme-button-text-color);\n  cursor: pointer;\n}\n\n.add-group-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  width: 90%;\n  margin: 5px auto;\n  padding: 2px 8px;\n  border-radius: 12px;\n  cursor: pointer;\n  color: var(--tg-theme-button-color);\n  background: rgba(138, 138, 138, 0.07);\n  border: 1.5px dashed var(--tg-theme-button-color);\n  opacity: 1;\n}\n\n.add-group-button:hover {\n  opacity: 1;\n  background: rgba(138, 138, 138, 0.15);\n}\n\n.brush-row-ghost {\n  opacity: 0.8;\n  background-color: var(--tg-theme-secondary-bg-color);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.5);\n  border-radius: 14px;\n  padding: 0;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
